import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "initial",
  message: "",
  isAuthenticated: false,
  metadata: {
    name: "",
    email: "",
    role: "user",
    completed_signup: true,
    default_tile_size: "medium",
    groupByValue: "Data Product",
  },
  userJourney: {
    showJourney: false,
    isNewUser: false,
    pagesToShow: {
      landingPage: true,
      detailsPage: true,
      AssistPage: true,
      HelpPage: true,
      accountSetupWelcome: true,
      accountSetupLocation: true,
      accountSetupFunction: true,
      accountSetupJobRole: true,
    },
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth(state) {
      state["status"] = initialState.status;
      state["message"] = initialState.message;
      state["isAuthenticated"] = initialState.isAuthenticated;
      state["metadata"] = initialState.metadata;
      state["userJourney"] = initialState.userJourney;
    },
    loginSuccessful(state, action) {
      state["status"] = "success";
      state["metadata"] = action.payload;
      state["isAuthenticated"] = true;
      state["userJourney"] = initialState.userJourney;
    },
    updateUserJourney(state, action) {
      state["userJourney"] = {
        ...state["userJourney"],
        showJourney: action.payload,
      };
    },
    setNewUser(state, action) {
      state["userJourney"] = {
        ...state["userJourney"],
        isNewUser: action.payload,
      };
    },
    updateNewUserJourneyPages(state, action) {
      state["userJourney"] = {
        ...state["userJourney"],
        pagesToShow: { ...state["userJourney"].pagesToShow, ...action.payload },
      };
    },
    loginFailed(state) {
      state["status"] = "failed";
      state["metadata"] = initialState.metadata;
      state["isAuthenticated"] = false;
    },
    logout(state) {
      state["status"] = "failed";
      state["metadata"] = initialState.metadata;
      state["isAuthenticated"] = false;
    },
    updateMetadataField(state, action) {
      state.metadata[action.payload?.key] = action.payload?.value;
    },
    updateGroupByValue(state, action) {
      state.metadata.groupByValue = action.payload;
    },
  },
});

export const {
  resetAuth,
  loginSuccessful,
  loginFailed,
  logout,
  updateUserJourney,
  setNewUser,
  updateNewUserJourneyPages,
  updateMetadataField,
  updateGroupByValue,
} = authSlice.actions;
export default authSlice.reducer;
